import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Login() {
  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#0B0C10]" data-testid="login-page">
      <div className="hidden lg:block relative">
        <img src="https://customer-assets.emergentagent.com/job_strategy-hub-236/artifacts/rr8uc9t9_18167.jpg" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0C10] via-[#0B0C10]/60 to-[#0B0C10]/40" />
        <div className="absolute bottom-12 left-12 right-12">
          <span className="h-11 w-11 grid place-items-center border border-[#D4AF37] text-[#D4AF37] font-display text-xl">MR</span>
          <h2 className="font-display text-3xl text-white mt-6 font-light leading-tight">Join the community of empowered business leaders.</h2>
          <p className="text-[#9CA3AF] mt-4 max-w-sm">Free courses on branding, marketing & business fundamentals — for members.</p>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#9CA3AF] hover:text-white transition-colors mb-12" data-testid="login-back">
            <ArrowLeft size={16} /> Back to home
          </Link>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37]">Member Access</p>
          <h1 className="font-display text-4xl text-white mt-4 font-light">Welcome.</h1>
          <p className="text-[#9CA3AF] mt-3">Sign in to access your free course library and community.</p>

          <button onClick={handleGoogle} className="w-full mt-10 bg-white text-[#0B0C10] font-medium hover:bg-[#f1f1f1] transition-colors rounded-sm px-6 py-4 flex items-center justify-center gap-3" data-testid="google-login-button">
            <svg width="20" height="20" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/><path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/></svg>
            Continue with Google
          </button>
          <p className="text-xs text-[#6B7280] mt-6 text-center">By continuing you agree to our terms of service and privacy policy.</p>
        </div>
      </div>
    </div>
  );
}
